import { TRANSLATIONS } from './translations';

/**
 * Which translated label goes with each SignupLeadInterests value.
 *
 * One map rather than a `switch` in each screen: the pre-launch form offers
 * these as pills and the admin panel prints them back as tags, and the day a
 * fifth is added it has to appear in both or in neither.
 */
export const SIGNUP_LEAD_INTEREST_LABEL_KEYS: Record<string, string> = {
  HasMachinery: TRANSLATIONS.PRELAUNCH_INTEREST_HAS_MACHINERY,
  WantsMachinery: TRANSLATIONS.PRELAUNCH_INTEREST_WANTS_MACHINERY,
  OffersServices: TRANSLATIONS.PRELAUNCH_INTEREST_OFFERS_SERVICES,
  WantsServices: TRANSLATIONS.PRELAUNCH_INTEREST_WANTS_SERVICES,
};
